import type {HotelTileLayoutProps} from '@/components/HotelTileLayout';

import styled from '@emotion/styled';
import {Skeleton} from '@travel-frontend/ui-components';
import {forwardRef} from 'react';

import {HotelTileLayout} from '@/components/HotelTileLayout';

type Props = Omit<
  HotelTileLayoutProps,
  | 'imageElement'
  | 'categoryElement'
  | 'nameElement'
  | 'ratingElement'
  | 'priceElement'
>;

export const HotelTilePlaceholder = styled(
  forwardRef<HTMLDivElement, Props>(function HotelTilePlaceholder(props, ref) {
    return (
      <HotelTileLayout
        {...props}
        ref={ref}
        imageElement={<Skeleton variant="rect" height="100%" />}
        categoryElement={
          <Skeleton variant="rect" width="100px" height="16px" />
        }
        nameElement={<Skeleton variant="rect" width="200px" height="25px" />}
        ratingElement={<Skeleton variant="rect" width="70px" height="24px" />}
        priceElement={<Skeleton variant="rect" width="116px" height="36px" />}
      />
    );
  })
)``;
